import BaseProxy from "../../base-proxy";
import LocalStore from "../../../utilities/local-store-manager";

/**
 * @class GetUsersMeProxy
 * @description Class used for communicating GET requests with user API.
 * @author Koh Keng Hong
 * @version 1.0
 * @since November 29, 2018
 */
export default class GetUsersMeProxy {
  /**
   * @async
   * @function execute
   */
  async execute(authToken = "") {
    let baseProxy = new BaseProxy();
    let backendUrl = await baseProxy.getBackendUrl();
    let endpointUrl = `${backendUrl}/users/me`;

    if (!authToken) {
      let localStore = new LocalStore();
      authToken = localStore.getToken();

      if (!authToken) {
        return {};
      }
    }

    return await baseProxy.getAuthenticatedData(endpointUrl, authToken);
  }
}
